import React from 'react';
import { HeaderContent } from '../../components/Layout/HeaderContent';
import { BoxContent } from './styles';

const Bienvenidos = () => {
    return (
        <BoxContent>
            <div className='header'>
                <img src='/images/header_bienvenidos1.jpg' />
            </div>
            {/* <HeaderContent /> */}
            {/* <div className='video_bienvenida'>
                <video src="/bienvenidos.mp4" muted autoPlay loop> </video>
            </div> */}
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className="title">
                        <span className="bienvenidos text_blanco_huevo">BIENVENIDOS A <span className='mercado_rural'>MERCADO RURAL</span></span>
                    </div>
                    <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Descubrí un espacio donde el campo y la ciudad se encuentran</span> y acercan a tus manos productos seleccionados directamente de productores locales.</div>
                </div>
            </div>
            <div className="box">
                <div className="image">
                    <img src={`/images/bienvenidos1.jpg`} />
                </div>
            </div>
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className='description text_blanco_huevo'>Si buscás alimentos frescos, productos artesanales o simplemente un lugar para conectar con lo natural, Mercado Rural es tu punto de encuentro. <span className='text_amarillo_banana'>Formá parte de esta comunidad y llevate lo mejor del campo a tu mesa.</span></div>
                </div>
            </div>
            <div className="box">
                <div className="image">
                    <img src={`/images/bienvenidos2.jpg`} />
                </div>
            </div>
        </BoxContent>
    );
};

export default Bienvenidos;